import { IPricingPlan } from "../../content/pages/superadmin/settings/pricing-plans/pricing-plan.interface";
import { Showroom } from "../showroom/showroom";
import { Vendor } from "./vendor";

export class User {
	id?: number;
	user_group_id?: number;
	showroom_id?: number;
	showroom_location_id?: number;
	vendor_id?: number;
	name: string;
	email: string;
	password?: string;
	password_confirmation?: string;
	role?: string;
	type?: "retailer" | "manufacturer" | "superadmin";
	email_verified_at?: string;
	account_verified_at?: string;

	showroom?: Showroom;
	vendor?: Vendor;
	pricing_plan?: IPricingPlan;
	proposals_count?: number;
	orders_count?: number;
}
